import { useQuery } from '@tanstack/react-query';
import { getEventPricing } from '../api';

export const eventPricingKeys = {
  all: ['eventPricing'],
  detail: (eventId) => ['eventPricing', eventId],
};

export function useEventPricing(eventId, options = {}) {
  return useQuery({
    queryKey: eventPricingKeys.detail(eventId),
    queryFn: async () => {
      const res = await getEventPricing(eventId, { timeout: 200000 });
      return res.data;
    },
    staleTime: 5 * 60 * 1000,
    enabled: !!eventId,
    // Skybox blips (rate limit / timeout / expired token) surface as 503 and
    // are worth retrying; a genuine 404 is not, and neither is 401/403 — the
    // interceptor is already handling the redirect. Our own 429 gets exactly
    // one retry, after the window the server told us to wait for.
    retry: (failureCount, err) => {
      const status = err?.response?.status;
      if (status === 404 || status === 401 || status === 403) return false;
      if (status === 429) return failureCount < 1;
      return failureCount < 3;
    },
    retryDelay: (attempt, err) => {
      if (err?.response?.status === 429) {
        const retryAfter = Number(err?.response?.data?.retryAfter);
        const secs = Number.isFinite(retryAfter) && retryAfter > 0 ? retryAfter : 60;
        // +500 ms so we land just past the window boundary, not on it
        return Math.min(secs * 1000 + 500, 65000);
      }
      return Math.min(1000 * 2 ** attempt, 8000);
    },
    ...options,
  });
}
